import { z } from 'zod'

export const operationResponseSchema = z.object({
  id: z.string().guid(),
  tbankOperationId: z.string(),
  name: z.string().nullable(),
  operationDate: z.coerce.date(),
  type: z.number().int(),
  typeName: z.string(),
  description: z.string().nullable(),
  state: z.number().int(),
  stateName: z.string(),
  instrumentUid: z.string().nullable(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  payment: z.number(),
  price: z.number(),
  commission: z.number(),
  quantity: z.number().int(),
})

export type OperationResponseDto = z.infer<typeof operationResponseSchema>
